import * as z from "zod/v4";

export const updateContactInfoSelfServe: {
  name: "updateContactInfoSelfServe";
  input: z.ZodObject<{
    orderIdOrOrderNoOrConfirmationNo: z.ZodString;
    customerEmail: z.ZodString;
    email: z.ZodOptional<z.ZodNullable<z.ZodString>>;
    phone: z.ZodOptional<z.ZodNullable<z.ZodString>>;
  }>;
  output: z.ZodObject<{
    success: z.ZodBoolean;
    orderNumber: z.ZodString;
    error: z.ZodOptional<z.ZodString>;
    updatedContactInfo: z.ZodOptional<
      z.ZodObject<{
        email: z.ZodOptional<z.ZodNullable<z.ZodString>>;
        phone: z.ZodOptional<z.ZodNullable<z.ZodString>>;
      }>
    >;
  }>;
} = {
  name: "updateContactInfoSelfServe" as const,
  input: z.object({
    orderIdOrOrderNoOrConfirmationNo: z
      .string()
      .describe("The order number, ID, or confirmation number"),
    customerEmail: z
      .string()
      .describe("Customer's email address for verification"),
    email: z
      .string()
      .nullable()
      .optional()
      .describe("New email address for the customer"),
    phone: z
      .string()
      .nullable()
      .optional()
      .describe("New phone number for the customer"),
  }),
  output: z.object({
    success: z.boolean(),
    orderNumber: z.string(),
    error: z.string().optional(),
    updatedContactInfo: z
      .object({
        email: z.string().nullable().optional(),
        phone: z.string().nullable().optional(),
      })
      .optional(),
  }),
};
